jQuery(document).ready(function($) {

    $("button.button.button--primary.button-quick-options").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });

  
    $("div.card__badge span.badge.badge--bottom-left.color-accent-2").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
  $("form#customer_login button").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
 $("div.price.price--large.price--on-sale.price--show-badge span.badge.price__badge-sale.color-accent-2").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
  
  $("div.Collapsible__contentOuter").removeAttr("aria-labelledby");
$('img[src="https://cdn.shopify.com/s/files/1/0686/1075/2743/files/g-form-0-appearance.imageUrl-lw5ciu88-2.png?v=1715627847"]').attr('alt', 'Sana Georgia logo');
 $("button.shopify-payment-button__button").append("<span style='display:none'>.</span>")
  $("button.shopify-payment-button__more-options").append("<span style='display:none'>.</span>")
  $('img[src="//sanageorgia.com/cdn/shop/files/pexels-rene-asmussen-1358910_550x.jpg?v=1712716904"]').attr('alt', 'Premium bathroom collection');
$('img[src="//sanageorgia.com/cdn/shop/files/pexels-tony-smith-3505699_550x.jpg?v=1712717054"]').attr('alt', 'Premium kitchen collection');
$('img[src="//sanageorgia.com/cdn/shop/files/pexels-nadi-lindsay-2747070_550x.jpg?v=1712716983"]').attr('alt', 'Premium living room collection');
$('div.banner a[href="/collections/all"]').attr('aria-label', 'View all collections');


});